module.exports = __webpack_public_path__ + "img/surveyimage.dcccf611.png";